import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const sectionHeaderDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
    getTitle: async () => base.$('[data-hook="title-node"] > *').text(),
  };
};

export type SectionHeaderUniDriver = ReturnType<
  typeof sectionHeaderDriverFactory
>;
